export default __webpack_public_path__ + "static/media/2nd-place-badge.310b098e.svg";